module.exports = __webpack_public_path__ + "static/media/2.75x1.25.2993fcc4.png";